module.exports = __webpack_public_path__ + "static/img/11.0ff9a81.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/6/zh/11.png
// module id = oF86
// module chunks = 0